import { apiClient } from './client'

export type SeasonType = 'spring' | 'summer' | 'fall' | 'winter'
export type LeagueType =
  | 'asa_rec_league'
  | 'usssa_league'
  | 'usssa_tournament'
  | 'asa_tournament'
  | 'senior_rec'
  | 'senior_tournament'

export const SEASON_TYPE_LABELS: Record<SeasonType, string> = {
  spring: 'Spring',
  summer: 'Summer',
  fall: 'Fall',
  winter: 'Winter',
}

export const LEAGUE_TYPE_LABELS: Record<LeagueType, string> = {
  asa_rec_league: 'ASA Rec League',
  usssa_league: 'USSSA League',
  usssa_tournament: 'USSSA Tournament',
  asa_tournament: 'ASA Tournament',
  senior_rec: 'Senior Rec',
  senior_tournament: 'Senior Tournament',
}

export interface Season {
  season_id: number
  year: number
  season_type: SeasonType
  league_type: LeagueType
  notes?: string
  display_name?: string
}

export interface CreateSeasonRequest {
  year: number
  season_type: SeasonType
  league_type: LeagueType
  notes?: string
}

export interface UpdateSeasonRequest {
  year: number
  season_type: SeasonType
  league_type: LeagueType
  notes?: string
}

export const seasonsApi = {
  getAll: () => apiClient.get<Season[]>('/seasons'),
  getById: (id: string | number) => apiClient.get<Season>(`/seasons/${id}`),
  create: (data: CreateSeasonRequest) => apiClient.post<Season>('/seasons', data),
  update: (id: string | number, data: UpdateSeasonRequest) => apiClient.put<Season>(`/seasons/${id}`, data),
  delete: (id: string | number) => apiClient.delete(`/seasons/${id}`),
}
